
const store = new Vuex.Store({
    state: {
        sidebarOpened: false,
        lastPagePathHistory: [],
        syncORMs: {},
        syncORM: {},
        // isListBindEvent: false,
        customComponentConfig: {},
        onResetPageData: false,
        stopRouteLeave: false,
    },
    mutations: {
        pushLastPagePathHistory( state, payload ) {
            this.state.lastPagePathHistory.push({
                fullPath: payload.fullPath,
                pageData: payload.pageData
            });
        },
        resetPageData( state, payload ) {
            this.state.onResetPageData = true;
        },
    }
});

export default store;